import { InComponentLoader } from "../../../library/common/Loader";
import "../reportDashboard.scss";

// Loading state for the places a DataGrid's own LoadingOverlay can't cover: the
// plain-markup `.rdTable` breakdowns (which are not grids at all), and the
// first fetch behind a drill-down modal, where there is no grid on screen yet
// to overlay. The spinner itself is the app's shared InComponentLoader — the
// same primitive used for in-component loading elsewhere (feature/dashboard,
// feature/support) — so it picks up the brand colour and dark-mode handling
// from library/common/loader.scss. Only the centring/min-height wrapper is
// local, so swapping a table out for this doesn't collapse the card.
//
// Deliberately NOT named TableLoader: library/common/Loader already exports a
// `TableLoader`, which is the absolute overlay handed to DataGrid's
// LoadingOverlay slot (see DashboardTable). Two different jobs, so two
// different names rather than one shadowing the other.
const TableLoading = () => (
  <div className="rdTableLoader">
    <InComponentLoader />
  </div>
);

export default TableLoading;
